export const padDate = (value: number) => value < 10? `0${value}` : `${value}`;